import { Action, History, Transition } from 'history';
import { Duel } from 'src/types/data-types';
import { clientSession } from 'src/utils/session-storage';

// Keeps Back/Forward from leaving the quiz or moving between questions.
// history.block also registers beforeunload; ignore it so refresh can restore progress.
export function holdQuizHistory(navigator: unknown, onRestore: () => void): () => void {
  const historyNavigator = navigator as History;

  if (typeof window === 'undefined' || typeof historyNavigator?.block !== 'function') {
    return () => undefined;
  }

  const browserWindow = window as Window & {
    addEventListener: (
      type: string,
      listener: EventListenerOrEventListenerObject,
      options?: boolean | AddEventListenerOptions
    ) => void;
  };
  const originalAddEventListener = browserWindow.addEventListener.bind(window);

  browserWindow.addEventListener = (
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions
  ) => {
    if (type === 'beforeunload') {
      return;
    }

    originalAddEventListener(type, listener, options);
  };

  let unblock: () => void = () => undefined;

  try {
    unblock = historyNavigator.block((tx: Transition) => {
      if (tx.action === Action.Pop) {
        onRestore();
        return;
      }

      unblock();
      tx.retry();
    });
  } finally {
    browserWindow.addEventListener = originalAddEventListener;
  }

  return unblock;
}

export const getSessionDuel = (duels: Record<string, Duel> | null): Duel | undefined => {
  if (!duels) {
    return undefined;
  }

  const sessionData = clientSession.get();

  if (!sessionData?.partyAId || !sessionData?.partyBId) {
    return undefined;
  }

  const key = [sessionData.partyAId, sessionData.partyBId].sort().join('__');

  return duels[key];
};
